import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { isIE } from "react-device-detect";

import { useWindowScale } from "./hooks/WindowHooks";
import HighFrequencyWordGame from "./games/high-frequency-word/HighFrequencyWordGame";
import ContentWordGame from "./games/content-word/ContentWordGame";
import BlendingGame from "./games/blending/BlendingGame";
import PhonemeGame from "./games/phoneme/PhonemeGame";
import RotateNotice from "./components/RotateNotice";
import DndPreview from "./react-dnd/DndPreview";
import BrowserNotice from "./components/BrowserNotice";
import Placeholder from "./components/Placeholder";

const App = () => {
  const {
    scaleInit,
    ratio,
    scale,
    containerLeft,
    itemLeft,
    itemRight,
  } = useWindowScale();

  const containerStyle = {
    transform: `scale(${scale})`,
    left: `${containerLeft * -1}px`,
  };

  if (!scaleInit) {
    return <Placeholder />;
  }

  return (
    <div className="main-container" style={containerStyle}>
      {!isIE && (
        <>
          <DndPreview scale={scale} itemLeft={itemLeft} itemRight={itemRight} />
          <Router basename={process.env.REACT_APP_ROUTE_PATH}>
            <Switch>
              <Route path="/high-frequency-word">
                <HighFrequencyWordGame itemLeft={itemLeft} scale={scale} />
              </Route>
              <Route path="/content-word">
                <ContentWordGame itemLeft={itemLeft} />
              </Route>
              <Route path="/blending">
                <BlendingGame scale={scale} itemLeft={itemLeft} ratio={ratio} />
              </Route>
              <Route path="/phoneme">
                <PhonemeGame scale={scale} itemLeft={itemLeft} />
              </Route>
              <Route path="*">
                <Placeholder type="invalid" />
              </Route>
            </Switch>
          </Router>
        </>
      )}
      {isIE && <BrowserNotice ratio={ratio} scale={scale} left={itemLeft} />}
      <RotateNotice ratio={ratio} scale={scale} left={itemLeft} />
    </div>
  );
};

export default App;
